import React from "react";
import { Button } from "../../components/general/Button/Button";
import { NotFoundButtonsContainer } from "./elements/NotFoundButtonsContainer";
import styled from "@emotion/styled";
import { Text } from "components/general/Text";
import { GlobalStore } from "store/global/GlobalStore";
import { css } from "@emotion/react";
import { ReactComponent as NotFoundIcon } from "../../img/404/404_Image.svg";
import { BEBOP_ROUTES } from "config/consts";

export const NotFound: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);

  return (
    <Container>
      <NotFoundIcon />
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          align-self: stretch;
          text-align: center;
        `}
      >
        <Text
          textStyle="Header"
          size="Super"
          color={theme.font.primary.default}
          textCss={css`
            // Override theme as it's not got a type in figma.
            font-size: 40px;
            font-weight: 800;
          `}
        >
          We couldn't find that page...
        </Text>
        <Text
          textStyle="Title"
          size="Large"
          color={theme.font.primary.default}
          textCss={css`
            text-align: center;
          `}
        >
          Whatever you're looking for, it’s not here. Maybe you should try someplace else.
        </Text>
      </div>
      <NotFoundButtonsContainer>
        <Button
          navigateTo={BEBOP_ROUTES.Trade}
          text={"Return home"}
          textSize="Large"
          buttonCss={css`
            border-radius: 14px;
            width: 168px;
            padding: 19px 18px;
            display: flex;
            justify-content: center;
            align-items: center;
          `}
          buttonType={"primary"}
        />
      </NotFoundButtonsContainer>
    </Container>
  );
};

// Sub-components

export const Container = styled.div`
  display: flex;
  max-width: 584px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin: auto;
  height: 80%;
`;
